import { SelectionCheckbox as e } from "./SelectionCheckbox.mjs";
import { useTableColumns as t } from "./useTableColumns.mjs";
import { OuterWrapper as n, ScrollWrapper as r, StyledTable as i, TH as a, THead as o } from "./TableStyles.mjs";
import { useOptionalTableContext as s } from "./TableProvider.mjs";
import { ElementScrollBody as c, WindowScrollBody as l } from "./TableBody.mjs";
import { useEffect as u, useRef as d, useState as f } from "react";
import { useTranslation as p } from "@maat/store-i18n";
import { Fragment as m, jsx as h, jsxs as ee } from "react/jsx-runtime";
//#region src/components/Table/Table.tsx
var g = ({ data: g, columns: _, onRowClick: v, className: y, style: b, emptyMessage: x, selectable: te = !1, selectedRows: S, onSelectionChange: C, rowActions: w, rowKey: T, getRowStyle: E, isLoading: D, isFetchingNextPage: O, onEndReached: k, maxHeight: A, scrollTargetRef: j }) => {
	let { t: M } = p("ds"), N = s(), P = g ?? N?.data ?? [], F = S ?? N?.selectedRows ?? [], I = C ?? N?.onSelectionChange, L = D ?? N?.isLoading ?? !1, R = O ?? N?.isFetchingNextPage ?? !1, z = x ?? N?.emptyMessage ?? M("ds:table.empty"), B = A ?? N?.maxHeight, V = j ?? N?.scrollTargetRef, H = d(null), [U, W] = f(!1), G = V ? "external" : B == null ? "window" : "internal", K = B == null ? void 0 : typeof B == "number" ? `${B}px` : B;
	u(() => {
		let e = () => {
			H.current && W(H.current.scrollLeft > 0);
		}, t = H.current;
		return t?.addEventListener("scroll", e, { passive: !0 }), () => t?.removeEventListener("scroll", e);
	}, []);
	let q = t({
		columns: _,
		selectable: te,
		rowActions: w
	}), J = (e, t) => T ? typeof T == "function" ? T(e) : String(e[T]) : e.id ?? t, Y = P.length > 0 && F.length === P.length, X = F.length > 0 && F.length < P.length, Z = () => {
		I && I(Y ? [] : [...P]);
	}, Q = (e) => {
		I && (F.some((t) => t.id === e.id) ? I(F.filter((t) => t.id !== e.id)) : I([...F, e]));
	}, ne = (t, n) => n.id === "__selection__" ? /* @__PURE__ */ h("div", {
		onClick: (e) => e.stopPropagation(),
		children: /* @__PURE__ */ h(e, {
			checked: F.some((e) => e.id === t.id),
			onCheckedChange: () => Q(t)
		})
	}) : n.id === "__actions__" && w ? /* @__PURE__ */ h("div", {
		onClick: (e) => e.stopPropagation(),
		children: w(t)
	}) : typeof n.accessor == "function" ? n.accessor(t) : n.accessor ? t[n.accessor] : null;
	if (!L && P.length === 0 && !z) return /* @__PURE__ */ h(m, {});
	let $ = {
		data: P,
		processedColumns: q,
		isLoading: L,
		isFetchingNextPage: R,
		emptyMessage: z,
		selectedRows: F,
		onRowClick: v,
		getRowKey: J,
		getRowStyle: E,
		renderCell: ne,
		onEndReached: k
	};
	return /* @__PURE__ */ h(n, {
		className: y,
		style: b,
		$maxHeight: K,
		children: /* @__PURE__ */ h(r, {
			ref: H,
			$isScrolled: U,
			className: U ? "is-scrolled" : "",
			children: /* @__PURE__ */ ee(i, { children: [/* @__PURE__ */ h(o, { children: /* @__PURE__ */ h("tr", { children: q.map((t, n) => {
				let r = t.id === "__selection__";
				return /* @__PURE__ */ h(a, {
					className: t.className,
					$width: t.width,
					$align: t.align ?? "left",
					$pinned: t.pinned,
					$offset: t._offset,
					"data-is-selection": r,
					children: r ? /* @__PURE__ */ h(e, {
						checked: Y ? !0 : X ? "indeterminate" : !1,
						onCheckedChange: Z
					}) : t.header
				}, t.id || n);
			}) }) }), G === "window" ? /* @__PURE__ */ h(l, { ...$ }) : /* @__PURE__ */ h(c, {
				...$,
				scrollElementRef: G === "external" ? V : H
			})] })
		})
	});
};
//#endregion
export { g as Table };
